// src/views/components/Motion/TiltCard.jsx
import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion';

const TiltCard = ({
  children,
  className = '',
  style = {},
  onClick,
  maxTilt = 12,
  glare = true,
}) => {
  const cardRef = useRef(null);
  const shouldReduceMotion = useReducedMotion();

  // Framer Motion values bypass React render cycle completely during mousemove
  const rawRotateX = useMotionValue(0);
  const rawRotateY = useMotionValue(0);
  const rawGlareX = useMotionValue(50);
  const rawGlareY = useMotionValue(50);
  const rawGlareOpacity = useMotionValue(0);

  const rotateX = useSpring(rawRotateX, { stiffness: 300, damping: 20 });
  const rotateY = useSpring(rawRotateY, { stiffness: 300, damping: 20 });
  const glareOpacity = useSpring(rawGlareOpacity, { stiffness: 300, damping: 20 });

  const handleMouseMove = (e) => {
    if (!cardRef.current || shouldReduceMotion) return;
    const rect = cardRef.current.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;

    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const calcRotateX = ((mouseY - height / 2) / (height / 2)) * -maxTilt;
    const calcRotateY = ((mouseX - width / 2) / (width / 2)) * maxTilt;

    rawRotateX.set(calcRotateX);
    rawRotateY.set(calcRotateY);
    rawGlareX.set((mouseX / width) * 100);
    rawGlareY.set((mouseY / height) * 100);
    rawGlareOpacity.set(0.15);
  };

  const handleMouseLeave = () => {
    rawRotateX.set(0);
    rawRotateY.set(0);
    rawGlareOpacity.set(0);
  };

  return (
    <motion.div
      ref={cardRef}
      className={`tilt-card-wrapper ${className}`}
      onClick={onClick}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        rotateX,
        rotateY,
        transformStyle: 'preserve-3d',
        perspective: 1000,
        position: 'relative',
        willChange: 'transform',
        ...style,
      }}
    >
      {children}
      {glare && !shouldReduceMotion && (
        <motion.div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: 'inherit',
            pointerEvents: 'none',
            background: `radial-gradient(circle at 50% 50%, rgba(255,255,255,0.4) 0%, transparent 60%)`,
            opacity: glareOpacity,
            zIndex: 10,
          }}
        />
      )}
    </motion.div>
  );
};

export default TiltCard;
